<template>
  <div
    ref="menu"
    class="calico-navbar-menu"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "CalicoNavbarMenu",
};
</script>

<style scoped lang="scss">
.calico-navbar-menu {
  @include stack-space($space-small);
  padding: $space-xsmall;
  border-radius: $radius-small;
  background-color: $color-white;
  box-shadow: 0px 4px 15px 0px #0000000D;
  z-index: $z-index-dialog;
}
</style>